import React from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  Separator,
  LightSeparator,
  Title,
  Desc,
} from './common/styles';
import LikeOptionsControl from './like-options-control';
import CommentOptionsControl from './comment-options-control';
import MentionOptionsControl from './mention-options-control';

export default function NotificationsControl(props) {
  return (
    <Container>
      <Title>Notifications</Title>
      <Desc>
        We’ll email you notifications when people engage with your wires. If you receive
        Wrap Up emails, we’ll add your notifications to your selected Wrap Ups. How
        frequently would you like to receive notification emails?
      </Desc>
      <LikeOptionsControl options={props.notifyOnLikeOptions} />
      <LightSeparator />
      <CommentOptionsControl options={props.notifyOnCommentOptions} />
      <LightSeparator />
      <MentionOptionsControl options={props.notifyOnMentionOptions} />
      <Separator />
    </Container>
  );
}

NotificationsControl.propTypes = {
  notifyOnLikeOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  notifyOnCommentOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  notifyOnMentionOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
};
